<!--
Voting redirect screen
@author ab557z
-->
<template>
  <div id="contain" class="container">
    <Nav name="Voting" :back="1===2"/>
  </div>
</template>

<script>
export default {
  name: 'VotingRedirect',
  data () {
    return {
      values: {}
    }
  },

  mounted () {
    this.$router.push('/voting/login/')
  },
  methods: {
  }
}
</script>
